// Global JavaScript for Icône Esthétique theme

document.addEventListener('DOMContentLoaded', function() {
  // Mobile menu toggle (if needed)
  const mobileMenuButtons = document.querySelectorAll('[data-mobile-menu-toggle]');
  
  mobileMenuButtons.forEach(button => {
    button.addEventListener('click', function() {
      const menu = document.querySelector('[data-mobile-menu]');
      if (menu) {
        menu.classList.toggle('is-open');
      }
    });
  });

  // Close mobile menu on outside click
  document.addEventListener('click', function(event) {
    const mobileMenu = document.querySelector('[data-mobile-menu]');
    const mobileMenuButton = document.querySelector('[data-mobile-menu-toggle]');
    
    if (mobileMenu && mobileMenuButton) {
      if (!mobileMenu.contains(event.target) && !mobileMenuButton.contains(event.target)) {
        mobileMenu.classList.remove('is-open');
      }
    }
  });

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href !== '#' && href !== '#MainContent') {
        e.preventDefault();
        const target = document.querySelector(href);
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    });
  });

  // Add class to header on scroll
  const header = document.querySelector('header');
  if (header) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 50) {
        header.classList.add('header--scrolled');
      } else {
        header.classList.remove('header--scrolled');
      }
    });
  }
});

// Utility function for debouncing
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Export for use in other scripts
window.themeUtils = {
  debounce: debounce
};
